// extracted by mini-css-extract-plugin
export default {"section":"NB-z","inSectionButton":"OB-z","addressCard":"PB-z","disabled":"QB-z","cautionBox":"RB-z","failureBox":"SB-z","fade-out":"TB-z","successBox":"UB-z"};